module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Mastercard-0bcb4c5d95d4bdfa76fc7f1f5616cd01.svg";